import {
    USER_AUTHENTICATE_SUCCESS_ACTION,
    USER_AUTHENTICATE_BEGIN_ACTION,
    USER_AUTHENTICATE_FAIL_ACTION,
    USER_LOGOUT_ACTION
} from "../constants";

//Default initial state to use for the reducer
let initialState = {
    status: 'unauthenticated',
    token: null
};

export default function(state = initialState, action) {

    switch(action.type) {

        case USER_AUTHENTICATE_BEGIN_ACTION:
            return {
                status: 'authenticating',
                token: null
            };

        case USER_AUTHENTICATE_FAIL_ACTION:
            return {
                status: 'invalid',
                token: null
            };

        case USER_AUTHENTICATE_SUCCESS_ACTION:
            return {
                status: 'valid',
                token: action.payload
            };

        case USER_LOGOUT_ACTION:
            return {
                status: 'unauthenticated',
                token: null
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/authentication.js